import React from 'react';
import { Section } from './ui/Section';
import { User, CheckCircle2, ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export default function ForWhomSection() {
  const points = ['Trabajas, tienes familia o simplemente tienes la cabeza llena', 'Llegas cansada y lo último que quieres es «ponerte creativa» con la cena', 'Ya intentaste planners, listas, recetas guardadas… y no se sostuvieron', 'Te duele gastar en comida de último minuto y después sentir culpa'];
  return <Section className="bg-brand-cream-dark" data-id="element-127">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-128">
        <div className="order-2 md:order-1" data-id="element-129">
          <motion.div whileHover={{
          scale: 1.02
        }} className="bg-white p-8 rounded-xl border-l-4 border-brand-brown shadow-lg relative overflow-hidden" data-id="element-130">
            <div className="relative z-10" data-id="element-131">
              <User className="text-brand-brown mb-4" size={40} data-id="element-132" />
              <p className="font-heading text-2xl md:text-3xl text-slate-800 italic leading-relaxed tracking-wide" data-id="element-133">
                «Cargo con todo. Trato de hacerlo bien. No tengo margen para
                fallar.»
              </p>
            </div>
          </motion.div>
          <p className="mt-8 text-xl text-slate-500 text-center md:text-left" data-id="element-134">
            Porque cuando la cena falla, no falla «la cena». <br data-id="element-135" />
            <span className="text-slate-900 font-bold" data-id="element-136">
              Falla tu sensación de control.
            </span>
          </p>
        </div>

        <div className="order-1 md:order-2" data-id="element-137">
          <h2 className="font-heading text-4xl text-slate-900 mb-8 uppercase tracking-wide" data-id="element-138">
            ¿Esto es para ti?
          </h2>
          <ul className="space-y-6" data-id="element-139">
            {points.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.15
          }} className="flex items-start group" data-id="element-140">
                <motion.div initial={{
              scale: 0,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: index * 0.15 + 0.2,
              type: 'spring'
            }} data-id="element-141">
                  <CheckCircle2 className="flex-shrink-0 w-6 h-6 mt-1 text-brand-brown mr-4 group-hover:text-brand-purple transition-colors" data-id="element-142" />
                </motion.div>
                <span className="text-xl text-slate-600 group-hover:text-slate-900 transition-colors" data-id="element-143">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          delay: 1
        }} className="mt-8 flex items-center gap-2 text-brand-purple text-sm font-medium" data-id="element-144">
            <span data-id="element-145">Si te identificas, sigue leyendo</span>
            <ArrowDown size={16} className="animate-bounce" data-id="element-146" />
          </motion.div>
        </div>
      </div>
    </Section>;
}